module.exports = __webpack_public_path__ + "img/comment.791a2a58.svg";